import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select2 from "react-select";
import { STATUS } from "rsuite/esm/internals/constants";
const EditSubpackageSubsriber = (props) => {
  const navigate = useNavigate();
  const { id, subpackageId, subscriberId, pivot } = useParams();
  const [isSaving, setIsSaving] = useState(false);
  const [user, setUser] = useState("");
  const [item, setItem] = useState({
    start_date: "",
    remaining_bookings: "",
    pivot_id: "",
    status: "",
    expiry_date: "",
  });

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "Changes have been done successfully"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [remainingBookings, setRemainingBookings] = useState("");
  const [pivotId, setPivotId] = useState("");
  const handleChangeRemainingBookings = (newValue) => {
    setItem({ ...item, remaining_bookings: newValue });
    setRemainingBookingsError("");
  };
  const [remainingBookingsError, setRemainingBookingsError] = useState("");
  const handleChangeStartDate = (newValue) => {
    setItem({ ...item, start_date: newValue });
  };
  const handleChangeExpiryDate = (newValue) => {
    setItem({ ...item, expiry_date: newValue });
  };
  const handleSelectChangeStatus = (newValue) => {
    setItem({ ...item, status: newValue });
  };
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(
        `/packages/${id}/subpackages/${subpackageId}/subscribers/${subscriberId}/booking/${pivot}`
      );
      console.log("test=", response?.data?.data?.pivot?.id);
      setItem({
        remaining_bookings:
          response?.data?.data?.pivot?.remaining_bookings !== null
            ? String(response.data.data.pivot.remaining_bookings)
            : "",
        start_date:
          response?.data?.data?.pivot?.start_date !== null
            ? response?.data?.data?.pivot?.start_date
            : "",
        expiry_date:
          response?.data?.data?.pivot?.expiry_date !== null
            ? response?.data?.data?.pivot?.expiry_date
            : "",
        pivot_id:
          response?.data?.data?.pivot?.id !== null
            ? response?.data?.data?.pivot?.id
            : "",
        status: response?.data?.data?.pivot?.status
          ? response?.data?.data?.pivot?.status
          : "",
      });
    } catch (error) {
      console.log(error);
    }

    setIsSaving(false);
  }
  return (
    <Page
      narrowWidth
      backAction={{
        onAction: () =>
          navigate(
            `/admin/packages/${id}/subpackages/${subpackageId}/subscribers`
          ),
      }}
      title="Edit Subscriber"
    >
      <Card>
        <FormLayout>
          <TextField
            label="Remaining Bookings"
            value={item.remaining_bookings}
            onChange={handleChangeRemainingBookings}
            error={remainingBookingsError}
            type="number"
          />
          <FormLayout.Group>
            <TextField
              label="Start Date"
              value={item.start_date}
              onChange={handleChangeStartDate}
              type="date"
            />
            <TextField
              label="Expiry Date"
              value={item.expiry_date}
              onChange={handleChangeExpiryDate}
              type="date"
            />
          </FormLayout.Group>

          <Select
            label="Status"
            options={[
              // { label: "Pending", value: "pending" },
              { label: "Confirmed", value: "confirmed" },
              { label: "Cancelled", value: "cancelled" },
              {
                label: "Cancelled with no refund",
                value: "cancelled with no refund",
              },
            ]}
            onChange={handleSelectChangeStatus}
            value={item.status}
            placeholder="Please select"
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    console.log(item);
    if (item.remaining_bookings === "") {
      setRemainingBookingsError("This field is required");
    } else {
      setIsSaving(true);
      axios
        .post(`/package-bookings/${item.pivot_id}`, {
          remaining_bookings: item.remaining_bookings,
          start_date: item.start_date,
          status: item.status,
          expiry_date: item.expiry_date,
        })
        .then((result) => {
          setIsSaving(false);
          toggleActive();
        })
        .catch((err) => console.log(err));
    }
  }
};

export default EditSubpackageSubsriber;
